//促销类型
const PROMOTION_TYPE_DISCOUNT = "discount";
const PROMOTION_TYPES = [
  {
    label: "折扣",
    value: PROMOTION_TYPE_DISCOUNT,
  },
];

//订单范围类型
const ORDER_LIMIT_TYPE_NUM = "num";
const ORDER_LIMIT_TYPE_AMOUNT = "amount";
const ORDER_LIMIT_TYPES = [
  {
    label: "满数量",
    value: ORDER_LIMIT_TYPE_NUM,
    message: "请输入数量，如数值2代表满2件可参与",
    unit: "件",
  },
  {
    label: "满金额",
    value: ORDER_LIMIT_TYPE_AMOUNT,
    message: "请输入金额，如数值100代表满100元可参与",
    unit: "元",
  },
];

//折扣类型
const DISCOUNT_TYPE_RATE = "rate";
const DISCOUNT_TYPE_MINUS = "minus";
const DISCOUNT_TYPES = [
  {
    label: "打折",
    value: DISCOUNT_TYPE_RATE,
    message: "请输入折扣力度，如数值8.5代表8.5折",
    unit: "折",
  },
  {
    label: "减免",
    value: DISCOUNT_TYPE_MINUS,
    message: "请输入减免力度，如数值50代表50元",
    unit: "元",
  },
];

//范围类型
const RANGE_TYPE_INCLUDE = "include"; //包含
const RANGE_TYPE_EXCLUDE = "exclude"; //排除

export {
  PROMOTION_TYPE_DISCOUNT,
  PROMOTION_TYPES,
  ORDER_LIMIT_TYPE_NUM,
  ORDER_LIMIT_TYPE_AMOUNT,
  ORDER_LIMIT_TYPES,
  DISCOUNT_TYPE_RATE,
  DISCOUNT_TYPE_MINUS,
  DISCOUNT_TYPES,
  RANGE_TYPE_INCLUDE,
  RANGE_TYPE_EXCLUDE,
};
